import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import DesignationItemEdit from "./DesignationItemEdit";
import DesignationItemView from "./DesignationItemView";
import { DesignationItemCard } from "./DesignationItem.styles";
import { openTabState } from "./Designation.state";

const DesignationItem = ({ clearOpenId, openId, ...props }) => {
    const [edit, setEdit] = useState(false);
    const [openIds, setOpenIds] = useRecoilState(openTabState);
    const onClose = () => {
        setEdit(false)
        setOpenIds(
            openIds
                .filter(id => id !== props.id)
        )
    }

    const onEdit = () => {
        setEdit(true)
        setOpenIds(
            [
                ...openIds,
                props.id,
            ]
                .filter((id, index, self) => self && self.indexOf(id) === index)
        )
    }

    useEffect(() => {
        if (openIds.includes(props.id) || openId === props.id) {
            setEdit(true);
            clearOpenId();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openId]);

    return (
        <DesignationItemCard>
            {
                edit
                    ? (
                        <DesignationItemEdit
                            onClose={onClose}
                            {...props}
                        />
                    )
                    : (
                        <DesignationItemView
                            onEdit={onEdit}
                            {...props}
                        />
                    )
            }
        </DesignationItemCard>
    );
};

export default DesignationItem;
